import { createAction } from 'redux-act'

export const initAdyenSDKSuccess = createAction('Adyen / SDK init success')

export const initAdyenCheckout = createAction<any>('Adyen / init checkout')
export const completeAdyenCheckout = createAction('Adyen / complete checkout')

export const apiInitAdyenStart = createAction('Adyen / API init start')
export const apiInitAdyenSuccess = createAction<any>('Adyen / API init success')
export const apiInitAdyenFail = createAction<any>('Adyen / API init fail')
